// @flow

export function messagesGroupedByReceiver (messages: Array<Object>): any {
  const groups = []
  let group = []

  for (let i = 0; i < messages.length; ++i) {
    if (!messages[i + 1]) {
      group.push(messages[i])
      groups.push(group)
      break
    }

    if (messages[i].from === messages[i + 1].from) {
      group.push(messages[i])
    } else {
      group.push(messages[i])
      groups.push(group)
      group = []
    }
  }

  return groups
}
